import { Box, TextField, Typography, styled } from "@mui/material";
import "../../theme/muiTypes.d.ts";

export const StyledTextField = styled(TextField, {
  shouldForwardProp: (prop) => prop !== "error",
})<{ error?: boolean }>(({ theme, error }) => ({
  "& .MuiOutlinedInput-root": {
    borderRadius: "8px",
    backgroundColor: error
      ? theme.palette.background?.red
      : theme.palette.background?.secondary,
    height: "48px",
    width: "100%",
    padding: "12px 16px",
    fontFamily: "Nunito, sans-serif",
    fontSize: "16px",
    "&.Mui-disabled": {
      opacity: "0.5",
    },
    "& .MuiAutocomplete-input": {
      height: "100%",
      padding: "0",
      boxSizing: "border-box",
      color: theme.palette.text?.primary,
      fontSize: "16px",
      fontFamily: "Nunito, sans-serif",
      "&::placeholder": {
        color: theme.palette.text?.secondary,
        opacity: 1,
      },
    },
    "& fieldset": {
      border: `${error ? "2px" : "1px"} solid ${
        error ? theme.palette.status?.error : theme.palette.border?.medium
      }`,
    },
    "&.Mui-focused fieldset": {
      border: `${error ? "2px" : "1px"} solid ${
        error ? theme.palette.status?.error : theme.palette.primary?.main
      }`,
      outline: "none",
    },
    "&:hover:not(.Mui-disabled) fieldset": {
      border: `${error ? "2px" : "1px"} solid ${
        error ? theme.palette.status?.error : theme.palette.primary?.main
      }`,
      outline: "none",
    },
  },
  "& .MuiAutocomplete-endAdornment": {
    right: "12px",
  },
}));

export const Label = styled(Typography)(({ theme }) => ({
  color: theme.palette.text?.secondary,
  fontFamily: "Nunito, sans-serif",
  fontSize: "12px",
  fontStyle: "normal",
  fontWeight: 400,
  lineHeight: "16px",
  marginBottom: "2px",
  paddingLeft: "8px",
  display: "block",
  "& span": {
    display: "none",
  },
}));

export const IconContainer = styled(Box)(() => ({
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
}));

